import { useState } from 'react';

import { message } from 'antd';
import { useHistory } from 'react-router-dom';
import { T } from 'react-translator-component';

import { useTheme } from '../../../../hooks/useTheme';
import { sendCode } from '../../../../services/authentication';

export const useRecoveryPage = () => {
  const history = useHistory();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [recaptchaResponse, setRecaptchaResponse] = useState('');
  const [isVerified, setIsVerified] = useState(false);
  const [isLoginLoading, setIsLoginLoading] = useState(false);

  const { theme } = useTheme();

  const onRecoverSuccess = (email) => {
    setIsLoginLoading(false);

    history.push({
      pathname: '/auth/recover/change',
      state: { email }
    });

    message.success(T('Check the code in your email.'));

    setIsSubmitting(false);
  };

  const onRecoverFailed = () => {
    setIsLoginLoading(false);

    message.error(T('Check if the email entered exists.'));

    setIsSubmitting(false);
  };

  const recaptchaLoaded = (response) => {
    if (response) {
      setRecaptchaResponse(response);

      setIsVerified(true);
    }
  };

  const recaptchaExpired = () => {
    setIsVerified(false);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();

    event.persist();

    setIsSubmitting(true);

    const userForm = {
      email: event.target.email.value,
      recaptchaResponse: recaptchaResponse
    };

    setIsLoginLoading(true)

    // IIFE to make it async with the request
    ;(async () => {
      const sendCodeData = await sendCode(userForm);
      const {
        data: { error },
        type,
      } = sendCodeData;

      type === 'success' && !error ? onRecoverSuccess(event.target.email.value) : onRecoverFailed();
    })();
  };

  return {
    handleFormSubmit,
    isLoginLoading,
    isSubmitting,
    isVerified,
    recaptchaExpired,
    recaptchaLoaded,
    theme
  };
};
